<template>
    <el-row>
        <!-- 新能开发文档 -->
        <el-dialog
                @opened="initFormData"
                :visible.sync="show"
                width="45%"
                title="创建开发需求">
            <el-form ref="createForm" :rules="rules" label-width="auto" :model="formData">
                <el-form-item prop="title" label="标题:" size="mini">
                    <el-input
                            type="textarea"
                            placeholder="请输入标题"
                            maxlength="32"
                            :autosize="{ minRows: 2, maxRows: 3}"
                            v-model="formData.title"
                            show-word-limit
                    ></el-input>
                </el-form-item>
                <el-form-item prop="content" label="详细内容:" size="mini">
                    <el-input
                            type="textarea"
                            placeholder="请输入详细内容"
                            maxlength="128"
                            :autosize="{ minRows: 2, maxRows: 4}"
                            v-model="formData.content"
                            show-word-limit
                    ></el-input>
                </el-form-item>
                <el-form-item label="优先级:" size="mini">
                    <el-rate style="padding: 3px 0" v-model="formData.level"></el-rate>
                </el-form-item>
            </el-form>
            <span slot="footer">
             <el-button :loading="createLoading" type="primary" size="mini" @click="createClick">提 交</el-button>
             <el-button size="mini" @click="close">取 消</el-button>
        </span>
        </el-dialog>

        <el-row style="margin: 10px 0">
            <el-button icon="el-icon-circle-plus" @click="open" size="mini" type="primary">创建开发需求</el-button>
        </el-row>
    </el-row>
</template>

<script>
    import {mapState, mapMutations} from 'vuex'

    export default {
        name: "CreateNewProReq",
        data() {
            const metaFormData = {
                title: '',
                content: '',
                level: 3,
            };
            Object.freeze(metaFormData);

            return {
                show: false,

                createLoading: false,

                url: `${this.$const.proRequirementUrl}`,

                // 表单数据
                formData: {
                    title: '',
                    content: '',
                    level: 3,
                },

                rules: {
                    title: [
                        {required: true, message: '请输入需求标题', trigger: 'blur'},
                        {min: 1, max: 32, message: '长度在 1 到 32 个字符', trigger: 'blur'}
                    ],
                },

                // 表单数据的初始信息(不可变)
                freezeFormData: metaFormData
            }
        },
        computed: {
            ...mapState(['currentUserInfo'])
        },
        methods: {
            /**
             * 点击提交按钮
             */
            createClick() {
                // 对表单数据进行验证
                this.$refs.createForm.validate((validated => {
                    if (validated) { //验证通过 validated 为 true
                        this._sendCreateRequest()
                    }
                }))
            },

            _sendCreateRequest() {
                this.createLoading = true;

                // 拷贝对象数据
                const data = JSON.parse(JSON.stringify(this.formData));
                data['created_username'] = this.currentUserInfo.username;
                this.$postRequest(this.url, data)
                    .then(response => {
                        this.addProRequirements([response.data]);
                        this.createLoading = false
                        this.close()
                    })
                    .catch(() => {
                        this.createLoading = false
                    })
            },

            /**
             * 打开创建对话框
             */
            open() {
                this.show = true
            },

            /**
             * 关闭创建对话框
             */
            close() {
                this.show = false
            },

            /**
             * 初始化表单数据
             */
            initFormData() {
                // 主要不要直接使用 this.formData = this.metaFormData
                // 使用上面的方式可能会出现两个表单
                for (let key in this.freezeFormData) {
                    this.formData[key] = this.freezeFormData[key]
                }
            },

            ...mapMutations(['addProRequirements'])
        },
    }
</script>

<style scoped>

</style>